// Mapa de cores por elemento (definido nas diretrizes de design).
// Nenhuma informação factual aqui; apenas apoio visual.
export const ELEMENT_COLORS = {
  madeira: { key: "madeira", label: "Madeira", primary: "#2C4A3E", secondary: "#3D6652", soft: "#E8F0EC", text: "#1B332A" },
  fogo: { key: "fogo", label: "Fogo", primary: "#A63A2B", secondary: "#C84C3C", soft: "#FCEEEB", text: "#6D1F14" },
  terra: { key: "terra", label: "Terra", primary: "#B87333", secondary: "#D48C46", soft: "#FBF1E6", text: "#6E3F15" },
  metal: { key: "metal", label: "Metal", primary: "#5A6B7C", secondary: "#7B8C9E", soft: "#EEF2F6", text: "#313D49" },
  agua: { key: "agua", label: "Água", primary: "#1E3A5F", secondary: "#2B4C7E", soft: "#EBF1F8", text: "#0F223C" },
};

export const elementColor = (key) => ELEMENT_COLORS[key] || ELEMENT_COLORS.madeira;
